import { useRef } from 'react';
import { getMod, useReduxSelector } from 'services/hooks';

export const useMain = () => {
  const isEducationRestricted =
    getMod('gamifiedEducation')?.hooks.useEducationRestricted() ?? false;

  const isShowBottomBar = useReduxSelector(
    (redux) => redux.main.isShowBottomBar
  );

  const wrapperRef = useRef<HTMLDivElement | null>(null);

  return {
    isShowBottomBar,
    wrapperRef,
    isEducationRestricted,
  };
};
